import config from "../config";
import handleResponse from "./helper";

export const analyticsService = {
	logEvent,
	logCompetitiveEvent,
	logCompetitiveAdminEvent,
	logStorageEvent,
	logStorageAdminEvent,
};

function logEvent(access, event, product_group_id = null, demo_id = null, calendar_event_id = null) {
	const requestOptions = {
		method: "POST",
		headers: { "Content-Type": "application/json", Authorization: "Bearer " + access },
		body: JSON.stringify({
			event: event,
			demo_id: demo_id,
			product_group_id: product_group_id,
			calendar_event_id: calendar_event_id,
		}),
	};
	return fetch(`${config.apiUrl}/analytics/log-event/`, requestOptions).then();
}

function logCompetitiveEvent(access, event, competitior_id = null, competitor_product_id = null, resource_type_id = null, resource_id = null, single_click_type_id = null, single_click_resource_id = null) {
	return postCompetitiveLog("log-competitive-event", access, {
		event: toCode(event),
		event_type: "1",
		competitor_id: toId(competitior_id),
		competitor_product_id: toId(competitor_product_id),
		resource_type_id: toId(resource_type_id),
		resource_id: toId(resource_id),
		single_click_type_id: toId(single_click_type_id),
		single_click_resource_id: toId(single_click_resource_id),
	});
}

function logCompetitiveAdminEvent(access, event, event_type = '1', competitior_id = null, competitor_product_id = null, resource_type_id = null, resource_id = null, single_click_type_id = null, single_click_resource_id = null) {
	return postCompetitiveLog("log-competitive-admin-event", access, {
		event: toCode(event),
		event_type: toCode(event_type),
		competitor_id: toId(competitior_id),
		competitor_product_id: toId(competitor_product_id),
		resource_type_id: toId(resource_type_id),
		resource_id: toId(resource_id),
		single_click_type_id: toId(single_click_type_id),
		single_click_resource_id: toId(single_click_resource_id),
	});
}

// backend accepts only numeric codes of up to 2 chars; anything else is dropped so it falls back to its default
const toCode = (value) => {
	const code = value === undefined || value === null ? "" : String(value);
	return /^\d{1,2}$/.test(code) ? code : undefined;
};

const toId = (value) => {
	if (value === undefined || value === null || value === "") return undefined;
	const id = Number(value);
	return Number.isInteger(id) ? id : undefined;
};

// resolves even on failure: logging must never block or break the UI
function postCompetitiveLog(path, access, raw) {
	const body = Object.fromEntries(Object.entries(raw).filter(([, v]) => v !== undefined));
	return fetch(`${config.apiUrl}/analytics/${path}/`, {
		method: "POST",
		headers: { "Content-Type": "application/json", Authorization: "Bearer " + access },
		body: JSON.stringify(body),
	})
		.then(() => undefined)
		.catch(() => undefined);
}

function logStorageEvent(access, event, application_id = null, application_primary_id = null, application_level_2_id = null) {
	const requestOptions = {
		method: "POST",
		headers: {
			"Content-Type": "application/json",
			Authorization: "Bearer " + access
		},
		body: JSON.stringify({
			event: event,
			event_source: '1',
			application_id: application_id !== null ? parseInt(application_id) : application_id,
			application_primary_id: application_primary_id !== null ? parseInt(application_primary_id) : application_primary_id,
			application_level_2_id: application_level_2_id !== null ? parseInt(application_level_2_id) : application_level_2_id,
		}),
	};
	return fetch(`${config.apiUrl}/analytics/log-storage-event/`, requestOptions).then();
}

function logStorageAdminEvent(access, event, application_id = null, application_primary_id = null, application_level_2_id = null) {
	const requestOptions = {
		method: "POST",
		headers: {
			"Content-Type": "application/json",
			Authorization: "Bearer " + access
		},
		body: JSON.stringify({
			event: event,
			event_source: '1',
			application_id: application_id !== null ? parseInt(application_id) : application_id,
			application_primary_id: application_primary_id !== null ? parseInt(application_primary_id) : application_primary_id,
			application_level_2_id: application_level_2_id !== null ? parseInt(application_level_2_id) : application_level_2_id,
		}),
	};
	return fetch(`${config.apiUrl}/analytics/log-storage-admin-event/`, requestOptions).then(handleResponse);
}

